import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../../i18n";
import "./LanguageSwitcher.css";

// Each language is labelled in its own language, so a visitor who can't read
// the current one can still find theirs.
const LANGUAGES = {
  es: { short: "ES", name: "Español" },
  en: { short: "EN", name: "English" },
};

export default function LanguageSwitcher({ className = "" }) {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language;

  return (
    <div className={`lang-switch ${className}`.trim()} role="group" aria-label={t("language.label")}>
      {SUPPORTED_LANGUAGES.map((lng) => {
        const active = current === lng;
        return (
          <button
            key={lng}
            type="button"
            lang={lng}
            className={`lang-switch-btn${active ? " is-active" : ""}`}
            aria-pressed={active}
            title={LANGUAGES[lng].name}
            onClick={() => i18n.changeLanguage(lng)}
          >
            {LANGUAGES[lng].short}
          </button>
        );
      })}
    </div>
  );
}
